import React from 'react'
import { useTranslation } from 'react-i18next'

import SubscribeToNewsletters from 'components/ParticipantProfile/ActionButtons//Buttons/SubscribeToNewsletters'
import PRMActionButtons from 'components/Shared/PRMActionButtons'
import { ParticipantProfileContext } from 'containers/ParticipantProfile'
import {
  onItemSelection,
  handlePRMActionButtonsClosure,
  formOptionsForParticipant,
} from 'components/ParticipantProfile/ActionButtons/Helper'
import BlockDialog from 'components/Participants/ParticipantActions/Block/BlockDialog'
import UnblockDialog from 'components/Participants/ParticipantActions/Block/UnblockDialog'
import UpgradeToProjectAdminModal from 'components/ParticipantProfile/MakeProjectAdmin/UpgradeToProjectAdminModal'
import { useAlert } from 'components/Shared/Alert'
import { sendActivationMail } from 'api/Participant/SendActivationMail/Action'
import { activateParticipant } from 'api/Participant/ActivateParticipant/Action'
import { useAppSelector } from 'redux/Hook'

export const ActionButtons = () => {
  const { roleName } = useAppSelector((state) => state.user.user)
  const { t } = useTranslation()
  const { showAlert } = useAlert()
  const { state, functions } = React.useContext(ParticipantProfileContext)
  const { participantSummary } = state
  const { getParticipant } = functions
  const [open, setOpen] = React.useState(false)
  const [currentModal, setCurrentModal] = React.useState('')
  const anchorRef = React.useRef<any>(null)
  const { blocked, type } = participantSummary

  const options = formOptionsForParticipant(participantSummary, roleName)
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    handlePRMActionButtonsClosure(event, anchorRef, setOpen)
  }

  const handleMenuItemClick = async (option: string) => {
    await onItemSelection(
      option,
      setCurrentModal,
      setOpen,
      showAlert,
      sendActivationMail,
      participantSummary.id,
      t,
      getParticipant,
      activateParticipant,
    )
  }

  const closeCurrentModal = (isCurrentModalOpen: boolean) => {
    if (!isCurrentModalOpen) {
      setCurrentModal('')
    }
  }

  return (
    <>
      <PRMActionButtons
        handleToggle={handleToggle}
        anchorRef={anchorRef}
        open={open}
        label={t(`participant.PRMActionButtons.participantDetails.buttonLabel`)}
        options={options}
        handleMenuItemClick={handleMenuItemClick}
        handleClose={handleClose}
        optionIcons={[]}
        buttonGroupId={'paticipant-details-actions'}
        page={'ParticipantDetails'}
      />
      <SubscribeToNewsletters
        isOpen={currentModal === 'susbscribeToNewsletter'}
        setModalVisibility={closeCurrentModal}
      />
      {!blocked && (
        <BlockDialog
          participant={participantSummary}
          isOpen={currentModal === 'blockParticipant'}
          setModalVisibility={closeCurrentModal}
          getParticipant={getParticipant}
        />
      )}
      {blocked && (
        <UnblockDialog
          participant={participantSummary}
          isOpen={currentModal === 'unblockParticipant'}
          setModalVisibility={closeCurrentModal}
          getParticipant={getParticipant}
        />
      )}
      {type !== 'ProjectAdmin' && (
        <UpgradeToProjectAdminModal
          context={ParticipantProfileContext}
          isOpen={currentModal === 'upgradeToProjectAdmin'}
          setModalVisibility={closeCurrentModal}
        />
      )}
    </>
  )
}

export default ActionButtons
